export const CONSTANTS = {
    I18N_KEYS: {
        MAIN_INFO: 'policies.mainInfo',
        COMPANY_LOGO: 'policies.companyLogo',
        CHOOSE_IMAGE: 'policies.chooseImage',
        SUBMIT: 'common.submit',
        CUSTOM_POLICIES: 'policies.customPolicies',
        SELECT_POLICIES: 'policies.selectPolicies',
        CUSTOM_POLICY_TEMPLATE: 'common.customPolicyTemplate',
        UPLOAD_NEW_DOC: 'dailyDocuments.uploadNewDoc',
    },
    URLS: {
        CUSTOM_POLICY_TEMPLATE:
            'https://docs.google.com/viewer?url=https://gs-public-manuals.s3.amazonaws.com/custom+policy+template/Custom+Policy+Document+Template+.docx',
    },
    API_IDS: {
        FETCH_CUSTOM_POLICY: 'fetchCustomPolicyApiID',
        UPLOAD_CUSTOM_POLICY: 'customPolicyUploadApi',
    },
    MISC: {
        FILE_TYPES_NOT_ALLOWED: 'Cannot upload audio and video',
        CUSTOM_POLICY_PARENT: 'policies',
    },
    FILE_TYPES: {
        IMAGES: ['image/jpeg', 'image/png'],
    }
};
